export const courses = [
  
    {
      name: "Your Vision Therapy Program",
      summary:
        "We all have our own style. Let’s co-create yours!",
      objectives:
        "You will learn: 1) The recommended order to watch the videos, 2) How to schedule your 1:1 mentoring sessions 3) Tips and tools for using the Piggyback joy games to develop vision.",
      embedId: "qbeu5e",
      img: "\\Academy\\titles\\YourProgram.png",
      handout: "\\Academy\\downloads\\YourProgram.pdf"
    },
    {
      name: "Reading Pathway",
      objectives:
        "You will learn:\n 1) Basic neuroscience for building a reading pathway in the brain.\n 2)Simple language description of the process to teach others.\n3) How vision interacts with language and coding to develop literacy.",
      summary:
        "Reading does not just happen. We must build a new brain pathway first",
      embedId: "4he9ej",
      img: "\\Academy\\titles\\ReadingPathways.png",
      handout: "\\Academy\\downloads\\ReadingPathways.pdf"
    },
    {
      name: "Five Things Children Need",
      objectives:
        "You will learn: 1) The five things typically developing children need to build reading pathways in the brain. 2) Ways to assess a child for gaps in each item.",
      summary: "To build a reading pathway children need five things",
      embedId: "m9polk",
      img: "\\Academy\\titles\\FiveThingsChildrenNeed.png",
      handout: "\\Academy\\downloads\\FiveThingsChildrenNeed.pdf"
    },
    {
      name: "Nervous System Responses",
      summary: "Stress, shame, and fear reduce visual function",
      objectives: "You will learn: 1)The role of shame and fear in delayed literacy. 2)The four nervous system responses to threat/danger. 3) What happens to vision when we are afraid.",
      embedId: "10fs07",
      img: "\\Academy\\titles\\NervousSystemResponses.png",
      handout: "\\Academy\\downloads\\NervousSystemResponses.pdf"
    },
    {
      name: "How Vision Supports Learning",
      objectives:
        "You will learn: 1) The basic function of the visual system. 2) The main areas of vision that support learning. 3) How to develop visual skills with Piggyback Joy.",
      summary:
        "Building a reading pathway is easier with optimally developed vision",
      embedId: "lvebhe",
      img: "\\Academy\\titles\\HowVisionSupportsLearning.png",
      handout: "\\Academy\\downloads\\HowVisionSupportsLearning.pdf"
    },
    {
      name: "Motor Learning",
      objectives:
        "You will learn: 1) The two main ways we learn to move, also known as motor learning. 2) About neuroplasticity, and how the brain adapts and changes. 3) The role of the mirror neuron (visual learning) system in human development.  4) How to apply motor learning and neuroplasticity to vision therapy.",
      summary:
        "Build your vision therapy on a strong foundation of the latest knowledge.",
      embedId: "eb4pnr",
      img: "\\Academy\\titles\\MotorLearning.png",
      handout: "\\Academy\\downloads\\MotorLearning.pdf"
    },
    {
      name: "The Facilitator’s Role",
      objectives:
        "You will learn: 1) The four pillars of vision therapy facilitation. 2) Ways to create an optimal environment. 3) Communication that builds connection. 4) Lessons from the world of gaming theory. 5) Tips for monitoring and adapting the program in real time.",
      summary:
        "Tools to create a joyful space for optimal vision therapy progress.",
      embedId: "07k35j",
      img: "\\Academy\\titles\\FacilitatorsRole.png",
      handout: "\\Academy\\downloads\\FacilitatorsRole.pdf"
    },
    {
      name: "Bridging Emotional Gaps in Vision Therapy",
      objectives:
        "You will learn: 1) To recognise the Karpman Drama Triangle. 2) How to be aware when it happens and the roles played. 3) How to flip to the Empowerment Triangle.",
      summary:
        "Empowering others begins with communication.",
      embedId: "17h5ua",
      img: "\\Academy\\titles\\BridgingEmotionalGaps.png",
      handout: "\\Academy\\downloads\\BridgingEmotionalGaps.pdf"
    },
    {
      name: "Visual Attention Part 1 of 3",
      objectives:
        "You will learn: 1) How visual attention impacts normal sensory-motor development.  2) How motor milestone achievement in infancy and early childhood supports learning readiness.",
      summary:
        "Good visual attention makes life easier.",
      embedId: "286mwh",
      img: "\\Academy\\titles\\VisualAttention_1.png",
      handout: "\\Academy\\downloads\\VisualAttention_1.pdf"
    },
    {
      name: "Visual Attention Part 2 of 3",
      objectives:
        "You will learn: 1) How visual attention impacts normal sensory-motor development.  2) How motor milestone achievement in infancy and early childhood supports learning readiness.",
      summary:
        "Good visual attention makes life easier.",
      embedId: "ffw2w5",
      img: "\\Academy\\titles\\VisualAttention_2.png",
      handout: "\\Academy\\downloads\\VisualAttention_2.pdf"
    },
    {
      name: "Visual Attention Part 3 of 3",
      objectives:
        "You will learn: 1) Ways to develop visual attention by scaffolding over normal behaviours. 2) How to monitor for visual overwhelm and adjust the program as you go.",
      summary:
        "Strategies to develop visual attention.",
      embedId: "fwr22t",
      img: "\\Academy\\titles\\VisualAttention_3.png",
      handout: "\\Academy\\downloads\\VisualAttention_3.pdf"
    },
    {
      name: "Coding Part 1 of 2",
      objectives:
        "You will learn: 1) The definition of coding, including a simple way to explain to others. 2) How coding begins at birth, and is the basis of language, communication and abstract thought. 3) How visual perception develops. 4) The role of meaningful social connection. 5) How reading is taught around the world.",
      summary:
        "Coding begins at birth. It is the foundation of language, reading and abstract thought. ",
      embedId: "ve2wfq",
      img: "\\Academy\\titles\\Coding_1.png",
      handout: "\\Academy\\downloads\\Coding_1.pdf"
    },
    {
      name: "Coding Part 2 of 2",
      objectives:
        "You will learn: 1) Current recommendations for teaching reading. 2) Role of vision in learning readiness with specific examples: 3) Embodied directionality for encoding letters 4) Visual scan adequate for phonemic awareness 5) Directed visual attention and memory for phonics 6) Sight word recognition and fluency",
      summary:
        "Visual skills are needed for encoding letters, numbers and words. ",
      embedId: "zpczh3",
      img: "\\Academy\\titles\\Coding_2.png",
      handout: "\\Academy\\downloads\\Coding_2.pdf"
    },
    {
      name: "Eye Movement Control Part 1 of 2",
      objectives:
        "You will learn: About the spatial priority map. The eye movements needed for reading.",
      summary:
        "Eye movements for reading must be taught.",
      embedId: "yu40gd",
      img: "\\Academy\\titles\\EyeMovementControl_1.png",
      handout: "\\Academy\\downloads\\EyeMovementControl_1.pdf"
    },
    {
      name: "Eye Movement Control Part 2 of 2",
      objectives:
        "You will learn: 1) How we draw upon past experience to create meaning. 2) How we use visual working memory. 3) The difference between parallel and serial processing.",
      summary:
        "Eye movements are complex and built by our life experiences.",
      embedId: "mwdvrj",
      img: "\\Academy\\titles\\EyeMovementControl_2.png",
      handout: "\\Academy\\downloads\\EyeMovementControl_2.pdf"
    },

    {
      name: "3 Dimensional Map",
      objectives:
        "You will learn: How the 3D multimodal map develops in infancy and childhood. The ideal environment and behaviours for 3D map expansion.  Activities to optimally develop 3D Map.",
      summary:
        "3D map of the world directs vision. Internally it is called imagination/visualisation. Externally it is called binocularity.",
      embedId: "p404sk",
      img: "\\Academy\\titles\\3DMap.png",
      handout: "\\Academy\\downloads\\3DMap.pdf"
    },

  ];